// extracted by mini-css-extract-plugin
export default {"score":"Xwn6jEAhHVxrTf3PzTIA"};